import { createApiHandler } from './handler';

const productOrders = {
  apiClient: null,
  path: '/admin/product-orders',

  setClient(apiClient) {
    this.apiClient = apiClient;
    this.initApiHandler();
  },

  initApiHandler() {
    Object.assign(this, createApiHandler(this.apiClient, this.path));
  },

  async send(id, form) {
    try {
      const response = await this.apiClient.post(`${this.path}/${id}/send`, form);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
};

export default productOrders;
